import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import { gsap } from 'gsap'
import Popup from '../components/team-popup.svelte'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		const $testimoniesWrap = $('#testimonies-wrap')
		if ($testimoniesWrap.length) {
			tns({
				container: '#testimonies-wrap',
				items: 1,
				slideBy: 1,
				autoplay: false,
				nav: true, //dots
				controls: false, //arrows
				touch: true,
				mouseDrag: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,
				autoHeight: true,
				speed: 750,
				controlsText: [
					'<span class="sr-only">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="17" height="52" viewBox="0 0 17 52"><path id="arrow_left" data-name="arrow left" class="cls-1" d="M0.6,26.128L16.506,2.284V49.971Z"/> </svg>',
					'<span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="17" height="52" viewBox="0 0 17 52"><path id="arrow_right" data-name="arrow left" class="cls-1" d="M0.6,26.128L16.506,2.284V49.971Z"/> </svg>',
				],
				responsive: {
					767: {
						nav: false, //dots
						controls: true, //arrows
					},
				},
			})
		}
		// window.onload = adjustContentPadding
		// window.onresize = adjustContentPadding
		// function adjustContentPadding() {
		// 	let $content = $('.main-content-wrap')
		// 	let $nav = $('.navbar-wrap')[0]
		// 	$content.css('padding-top', $nav.getBoundingClientRect().height)
		// }
		// let tl = gsap.timeline()
		gsap.from('#about-1 .half-img', { duration: 1, opacity: 0 })
		gsap.from('#about-1 .xmain', {
			scrollTrigger: { trigger: '#about-1 .xmain' },
			y: 25,
			duration: 1,
			delay: 1,
			opacity: 0,
		})
		gsap.from('#about-1 .about-bg-word', {
			scrollTrigger: { trigger: '#about-1 .about-bg-word' },
			y: 125,
			duration: 1.5,
			delay: 0.5,
			opacity: 0,
		})
		gsap.from('#about-2 .half-img', {
			scrollTrigger: { trigger: '#about-2 .half-img' },
			duration: 1,
			opacity: 0,
		})
		gsap.from('#about-2 .xmain', {
			scrollTrigger: { trigger: '#about-2 .xmain' },
			y: 25,
			duration: 1,
			opacity: 0,
		})
		gsap.from('#about-2 .about-bg-word', {
			scrollTrigger: { trigger: '#about-2 .about-bg-word' },
			y: 125,
			duration: 2.5,
			delay: 0.5,
			opacity: 0,
		})
	},
	finalize() {
		new Popup({
			target: document.body,
		})
	},
}
